<div class="auth-page-waiting spinner block mt-9 m-auto"></div>
